"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _config = require("../../../config/config");

var CompletedBy = function CompletedBy(_ref) {
  var filler = _ref.filler,
      handleChange = _ref.handleChange; // does nothing at present; left here until it can be restored

  var styles = {
    control: function control(base, state) {
      return (0, _extends2["default"])({}, base, {
        borderRadius: 0,
        boxShadow: 'none',
        borderTopStyle: 'none',
        borderRightStyle: 'none',
        borderLeftStyle: 'none',
        borderColor: state.isFocused ? '#00bed6' : '#9b9b9b',
        '&:hover': {
          borderColor: state.isFocused ? '#00bed6' : '#9b9b9b'
        },
        fontSize: 14,
        fontWeight: 300
      });
    },
    menu: function menu(base) {
      return (0, _extends2["default"])({}, base, {
        borderRadius: 0,
        boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.2);',
        fontSize: 14,
        fontWeight: 300,
        backgroundColor: '#f7f9ff'
      });
    },
    option: function option(base, state) {
      return (0, _extends2["default"])({}, base, {
        fontSize: 14,
        fontWeight: 300,
        color: '#53575a',

        /* eslint-disable-next-line */
        backgroundColor: state.isSelected ? '#e9ebef' : state.isFocused ? '#f7f9ff' : '#f7f9ff',
        cursor: 'pointer'
      });
    }
  };
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      controlId: "AlignmentControl",
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        marginTop: '0px'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        fontSize: 14,
        fontWeight: 300
      }
    }, "Completed by"),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.FormControl, {
      as: "select",
      name: "filler",
      value: filler || 'select',
      onChange: handleChange,
      styles: styles
    },
    /*#__PURE__*/
    _react["default"].createElement("option", {
      value: "select"
    }, "Select"),
    /*#__PURE__*/
    _react["default"].createElement("option", {
      value: "employee"
    }, "Applicant/Employee"),
    /*#__PURE__*/
    _react["default"].createElement("option", {
      value: "manager"
    }, "Manager/Admin")))
  );
};

CompletedBy.defaultProps = {
  filler: ''
};
CompletedBy.propTypes = process.env.NODE_ENV !== "production" ? {
  filler: _propTypes["default"].string,
  handleChange: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = CompletedBy;